import { Trans, useTranslation } from "react-i18next"
import { Dialog } from "primereact/dialog"
import { Button } from "primereact/button"
import './missingCreditsDialog.css'

export const MissingCreditsDialog = (props) => {

    const { t } = useTranslation();
    
    const handleConsultOffers = () => {
        // history.push({ pathname: '/profile_company', hash: "#factures", state: { adminImpersonatingRecruteurId } })
        props.setShowMissingCreditsPopup(false);
    };
    
    return (
        <Dialog 
            visible={props.showMissingCreditsPopup} 
            modal 
            className="mcd-container" 
            onHide={() => props.setShowMissingCreditsPopup(false)} 
            header="Crédits épuisés"
        >
            <div className="mcd-content">
                <p className="mcd-message"><Trans i18nKey={t('company.credits.sold_out_message', { 
                    date: props.nextCreditRenewalDate ? new Date(props.nextCreditRenewalDate).toLocaleDateString('fr-FR') : ''
                })} /></p>
                <Button 
                    label="Consulter nos offres"
                    className="p-button-raised mcd-button"
                    onClick={handleConsultOffers}
                />
            </div>
        </Dialog>
    )
}